<template>
  <div v-if="isLoading" class="trail-status" role="status" aria-live="polite">
    <span>{{ progressMessage }}</span>
    <progress
      v-if="progress > 0 && progress < 100"
      :value="progress"
      max="100"
      class="trail-status-progress"
    ></progress>
  </div>
</template>

<script>
export default {
  computed: {
    progress() {
      return this.$store.state.progress;
    },
    progressMessage() {
      return this.$store.state.progressMessage;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
};
</script>

<style>
.trail-status {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-height: 30px;
  padding: 6px 14px;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-size: 13px;
  line-height: 18px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.trail-status-progress {
  width: min(220px, 35vw);
  height: 5px;
  -webkit-appearance: none;
  appearance: none;
}

.trail-status-progress::-webkit-progress-bar {
  background: #555;
  border-radius: 10px;
}

.trail-status-progress::-webkit-progress-value {
  background: #7ab730;
  border-radius: 10px;
}

.trail-status-progress::-moz-progress-bar {
  background: #7ab730;
  border-radius: 10px;
}
</style>
